<flx-resources-page
  [showCustomActions]="true"
  class="h-full"
  pageTitle="Failed Process Start"
>
  <!-- The filters wrap under each other once the header's action line can't hold them side by side. -->
  <form
    [formGroup]="exceptionsFilterFG"
    class="flex flex-wrap items-center gap-2"
    flxResourcePageFirstAction
  >
    <flx-select
      [hasClear]="true"
      [hasSearch]="true"
      (filterChange)="processFilter$.next($event)"
      class="flx-ds w-64 min-w-0"
      formControlName="definitionName"
      placeholder="Filter by process definition"
    >
      @for (process of filteredApplicationProcesses(); track process.id) {
        <flx-select-option [value]="process">
          {{ process.resourceName }}
        </flx-select-option>
      }
    </flx-select>
    <div
      [formGroup]="dateRangeGroupFG"
      class="flex items-center gap-2"
    >
      <p-datepicker
        [defaultDate]="startTime"
        [showTime]="true"
        [showIcon]="true"
        [showClear]="true"
        class="flx-ds"
        dateFormat="dd M yy, "
        iconDisplay="input"
        formControlName="startDate"
        placeholder="From date"
      ></p-datepicker>
      <span> - </span>
      <p-datepicker
        [defaultDate]="endTime"
        [showTime]="true"
        [showIcon]="true"
        [showClear]="true"
        class="flx-ds"
        dateFormat="dd M yy, "
        iconDisplay="input"
        formControlName="endDate"
        placeholder="To date"
      ></p-datepicker>
    </div>
  </form>

  <ng-container ngProjectAs="[flxResourcesPageBody]">
    <flx-resources-grid
      [tableDef]="exceptionsTableColumns"
      [inputGridOptions]="gridOptions()"
      [rowClickEnabled]="true"
      (gridReady)="onGridReady($event)"
      (rowClick)="navigateToException($event)"
      class="h-full"
      emptyMsg="No exceptions found."
    ></flx-resources-grid>
  </ng-container>
</flx-resources-page>
